import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const LittleDotsPlaceholderSvg = () => (
  <svg
    width='1em'
    height='0.88em'
    viewBox='0 0 25 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='1.2998' cy='1.73187' r='0.832031' fill='#CBCFDD' />
    <circle cx='6.96387' cy='1.73187' r='0.832031' fill='#CBCFDD' />
    <circle cx='12.6279' cy='1.73187' r='0.832031' fill='#CBCFDD' />
    <circle cx='18.292' cy='1.73187' r='0.832031' fill='#CBCFDD' />
    <circle cx='23.9561' cy='1.73187' r='0.832031' fill='#CBCFDD' />
    <circle cx='1.2998' cy='6.39594' r='0.832031' fill='#CBCFDD' />
    <circle cx='6.96387' cy='6.39594' r='0.832031' fill='#CBCFDD' />
    <circle cx='12.6279' cy='6.39594' r='0.832031' fill='#CBCFDD' />
    <circle cx='18.292' cy='6.39594' r='0.832031' fill='#CBCFDD' />
    <circle cx='23.9561' cy='6.39594' r='0.832031' fill='#CBCFDD' />
    <circle cx='1.2998' cy='11.06' r='0.832031' fill='#CBCFDD' />
    <circle cx='6.96387' cy='11.06' r='0.832031' fill='#CBCFDD' />
    <circle cx='12.6279' cy='11.06' r='0.832031' fill='#CBCFDD' />
    <circle cx='18.292' cy='11.06' r='0.832031' fill='#CBCFDD' />
    <circle cx='23.9561' cy='11.06' r='0.832031' fill='#CBCFDD' />
    <circle cx='1.2998' cy='15.7241' r='0.832031' fill='#CBCFDD' />
    <circle cx='6.96387' cy='15.7241' r='0.832031' fill='#CBCFDD' />
    <circle cx='12.6279' cy='15.7241' r='0.832031' fill='#CBCFDD' />
    <circle cx='18.292' cy='15.7241' r='0.832031' fill='#CBCFDD' />
    <circle cx='23.9561' cy='15.7241' r='0.832031' fill='#CBCFDD' />
    <circle cx='1.2998' cy='20.3881' r='0.832031' fill='#CBCFDD' />
    <circle cx='6.96387' cy='20.3881' r='0.832031' fill='#CBCFDD' />
    <circle cx='12.6279' cy='20.3881' r='0.832031' fill='#CBCFDD' />
    <circle cx='18.292' cy='20.3881' r='0.832031' fill='#CBCFDD' />
    <circle cx='23.9561' cy='20.3881' r='0.832031' fill='#CBCFDD' />
  </svg>
);

export const LittleDotsPlaceholderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LittleDotsPlaceholderSvg} {...props} />
);
